import CreateWindow from "../puzzleWindow";
import "./index.css";
import { html, render } from "lit-html";
import { unsafeHTML } from "lit-html/directives/unsafe-html.js";
import LoginScreen from "./loginScreen";
import { tips } from "~src/tips/index.js";
import { exitButtonPosition } from "../../helpers/exitButtonPosition"
import { iOSallowScroll } from "../../helpers/iOSHacks";
import { setVhProperty } from "../../helpers/storeRealViewportHeight";
import { giveData } from "./data";
import { resizeJobs } from "../../helpers/windowResize";
import imagesLoaded from "imagesloaded"
import { pickText } from "../../textcontents";
import { isMobile } from "mobile-device-detect";

let twitterScroller;

const updateIosScroller = () => {
  // We need custom scoller for ios devices. 
  // This function updates the scroller dimensions when container is ready (=images loaded)
console.log({twitterScroller})
  if (!twitterScroller) return; // IF NOT DEFINED, WE ARE NOT IN IOS
  imagesLoaded("#twitter", function () {

    twitterScroller.updateDimensions()
    console.log("all loaded")
  });
}

const FlatPuzzle = function (noLogin, ebcallback) {
  //banana.jpg, @laura_banana,
  const Profiles = {
    laura_banana: {
      realName: pickText("twitter", "Name1"),
      profilePic: "banana.jpg",
      handle: pickText("twitter", "NickName1"),
      tweetsTotal: "220",
      desc: pickText("twitter", "Desc1"),
      followers: "332",
      following: "207",
      background: "bananatausta.jpg",
      joined: "06/2017",
      profileTweets: [0, 1, 2]
    },
    OliverTheOrange: {
      realName: pickText("twitter", "Name2"),
      profilePic: "orange.jpg",
      handle: pickText("twitter", "NickName2"),
      tweetsTotal: "462",
      desc: pickText("twitter", "Desc2"),
      followers: "345",
      following: "512",
      background: "orangetausta.jpg",
      joined: "02/2011",
      profileTweets: [3, 4, 5]
    },
    Meloni_6745792: {
      realName: pickText("twitter", "Name3"),
      profilePic: "meloni.jpg",
      handle: pickText("twitter", "NickName3"),
      tweetsTotal: "122",
      desc: pickText("twitter", "Desc3"),
      followers: "2001",
      following: "7",
      background: "melonitausta.jpg",
      joined: "3 days ago",
      profileTweets: [6, 7, 8]
    },
  };

  const Tweets = [
    {
      profilePic: Profiles["laura_banana"].profilePic,
      handle: Profiles["laura_banana"].handle,
      tweet: html`${unsafeHTML(pickText("twitter", "message2"))}`,
      comments: "3",
      showOnTimeline: true,
      retweets: "1",
      likes: "6",
      callbackData: {
        banana: true,
        feed: false,
      },
    },
    {
      profilePic: Profiles["laura_banana"].profilePic,
      handle: Profiles["laura_banana"].handle,
      tweet: html`${unsafeHTML(pickText("twitter", "message3"))}`,
      comments: "0",
      showOnTimeline: false,
      retweets: "0",
      likes: "8",
      callbackData: {
        banana: true,
        feed: false,
      },
    },
    {
      profilePic: "opettaja.jpg",
      handle: "@suokkilainen35",
      tweet: html`${unsafeHTML(pickText("twitter", "message4"))}`,
      newsHeader: pickText("twitter", "newsHeader"),
      newsPic: window.pakopeliPublicAssetUrl + "img/twitter/opettaja-uutinen.jpg",
      comments: "12",
      retweet: true,
      showOnTimeline: false,
      retweets: "8",
      likes: "67",
      callbackData: {
        banana: true,
        feed: false,
      },
    },
    {
      profilePic: Profiles["OliverTheOrange"].profilePic,
      handle: Profiles["OliverTheOrange"].handle,
      tweet: html`${unsafeHTML(pickText("twitter", "message1"))}`,
      comments: "25",
      retweets: "3",
      showOnTimeline: true,
      likes: "16",
      callbackData: {
        orange: true,
        feed: false,
      },
    },
    {
      profilePic: "selena.jpg",
      handle: "@sekoHelsinki92",
      tweet: html``,
      newsHeader: pickText("twitter", "newsHeader2"),
      newsPic: window.pakopeliPublicAssetUrl + "img/twitter/ensihoito.jpg",
      comments: "12",
      retweet: true,
      showOnTimeline: false,
      retweets: "8",
      likes: "67",
      callbackData: {
        orange: true,
        feed: false,
      },
    },
    {
      profilePic: Profiles["OliverTheOrange"].profilePic,
      handle: Profiles["OliverTheOrange"].handle,
      tweet: html`${unsafeHTML(pickText("twitter", "message5"))}`,
      comments: "8",
      retweets: "1",
      showOnTimeline: false,
      likes: "10",
      callbackData: {
        orange: true,
        feed: false,
      },
    },
    {
      profilePic: Profiles["Meloni_6745792"].profilePic,
      handle: Profiles["Meloni_6745792"].handle,
      tweet: html`${unsafeHTML(pickText("twitter", "message6"))}`,
      comments: "0",
      retweets: "1",
      showOnTimeline: true,
      likes: "0",
      callbackData: {
        meloni: true,
        feed: false,
      },
    },
    {
      profilePic: Profiles["Meloni_6745792"].profilePic,
      handle: Profiles["Meloni_6745792"].handle,
      tweet: html`There have been 3,542 deaths from vaccination in France! Think what the shit they feed you!  <span class="twitterHashtags"
    ><b>#vaccines #influenza #conspiracy </span>bit.ly/p/skdjKSDisjd...
      `,
      comments: "0",
      retweets: "0",
      showOnTimeline: false,
      likes: "2",
      callbackData: {
        meloni: true,
        feed: false,
      },
    },
    {
      profilePic: "munapaa.jpg",
      handle: "@y2k_123456",
      retweet: true,
      newsPic: window.pakopeliPublicAssetUrl + "img/twitter/rotat.jpg",
      newsHeader: "Influenza vaccines have killed experimental animal rats in the United States.",
      comments: "0",
      retweets: "1",
      showOnTimeline: false,
      likes: "0",
      callbackData: {
        meloni: true,
        feed: false,
      },
    },
  ];


  const Tweet = ({
    callback,
    profilePic,
    handle,
    tweet,
    retweets,
    comments,
    likes,
    newsHeader,
    retweet,
    newsPic,
  }) => html`
    <div class="tweet click banana" @click=${() => {
      window.scene.getSoundByName("twitterMouseClick")?.play();
      callback()
    }}>
      <div class="twitterProfilePic">
        <img class="" src="${window.pakopeliPublicAssetUrl}img/twitter/${profilePic}" />
      </div>
      <div class="twitterContent">
        <div class="twitterHandle">
          ${retweet
      ? html`<i class="icon-retweet" aria-hidden="true"></i>`
      : ``}
          @${handle}
        </div>
        <div class="twitterPost">${tweet}</div>
        ${newsHeader && newsPic
      ? html`<div class="twitter-Newsimage"><img src=${newsPic} /></div>
              <div class="twitter-News">${pickText("twitter", "news")} ${newsHeader}</div>`
      : null}
        <div class="twitterMeta">
          <div>
            <div>
              <img src="${window.pakopeliPublicAssetUrl}img/twitter/svg/kommentti.svg" />
            </div>
            <div>${comments}</div>
          </div>
          <div>
            <div>
              <img src="${window.pakopeliPublicAssetUrl}img/twitter/svg/retweet.svg" />
            </div>
            <div>${retweets}</div>
          </div>
          <div>
            <div><img src="${window.pakopeliPublicAssetUrl}img/twitter/svg/sydan.svg" /></div>
            <div>${likes}</div>
          </div>
          <div>
            <div><img src="${window.pakopeliPublicAssetUrl}img/twitter/svg/share.svg" /></div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
  `;

  const Profile = ({
    handle,
    tweetsTotal,
    background,
    realName,
    joined,
    followers,
    following,
    profilePic,
    profileTweets,
    desc,
  }) => html`
    <div id="orange" class="profiili">
      <div class="twitterProfiiliNavi">
        <div class="palaa" @click=${() => {
      window.scene.getSoundByName("twitterMouseClick")?.play();

      backToFeed()
    }}>
          <img src="${window.pakopeliPublicAssetUrl}img/twitter/svg/palaa.svg" />
        </div>
        <div class="profileOtsikko">
          <div class="handle">@${handle}</div>
          <div class="harmaa">${tweetsTotal} ${pickText("twitter", "tweetsTotal")}</div>
        </div>
      </div>
      <div class="profiiliTaustakuva">
        <img src="${window.pakopeliPublicAssetUrl}img/twitter/${background}" />
      </div>
      <div class="twitterProfilePicBig">
        <div class="pic">
          <img src="${window.pakopeliPublicAssetUrl}img/twitter/${profilePic}" />
        </div>
        <div class="seuraa">${pickText("twitter", "Follow")}</div>
      </div>
      <div class="metaWrapper">
        <div class="handle">${realName} @${handle}</div>
        <div class="desc">${desc}</div>
        <div class="metat">
          <div class="joined harmaa">
            <div><img src="${window.pakopeliPublicAssetUrl}img/twitter/svg/date.svg" /></div>
            <div>${pickText("twitter", "Joined")} ${joined}</div>
          </div>
        </div>
        <div class="seuraukset">
          <div>${followers} <span class="harmaa">${pickText("twitter", "Followers")}</span></div>
          <div>${following} <span class="harmaa">${pickText("twitter", "Following")}</span></div>
        </div>
        <div class="tweets-profile">
          ${profileTweets.map((e) => Tweet(Tweets[e]))}
        </div>
      </div>
    </div>
  `;

  const Twitter = ({ feed, orange, banana, meloni }) => html`
    <div id="parentTwitterWrapper">
      <div id="twitter">
        
        <div class="content">
          ${feed
      ? html`<div id="twitterFeed">
                <div class="twitterNavi">
                <div class="hakukentta">
                <div><img src="${window.pakopeliPublicAssetUrl}img/twitter/haku.svg" /></div>
                <div>${pickText("twitter", "Hashtag1")}</div>
              </div>
                  <div class="palaa" @click=${backToFeed}>
                    <img src="${window.pakopeliPublicAssetUrl}img/twitter/logo3.png" @click=${backToFeed} />
                  </div>

                </div>

                <div class="twitterWrapper">
                  ${Tweets.map((e) => {
        if (!e.showOnTimeline) return null;
        e = {
          ...e,
          callback: () => {
            render(Twitter(e.callbackData), puzzleWindow({}))
            updateIosScroller();
          },
        };
        return Tweet(e);
      })}
                </div>
              </div> `
      : ""}
          <!-- Profiles -->
          ${banana ? Profile(Profiles["laura_banana"]) : ""}
          ${orange ? Profile(Profiles["OliverTheOrange"]) : ""}
          ${meloni ? Profile(Profiles["Meloni_6745792"]) : ""}
        </div>
      </div>
    </div>
  `;

  function backToFeed() {
    render(
      Twitter({ feed: true, meloni: false, banana: false, orange: false }),
      puzzleWindow({})
    );
    updateIosScroller();
  }

  const puzzleWindow = ({ hidden }) =>
    CreateWindow({
      exitCallback: () => {
        ebcallback();

      },
      hidden: hidden ? hidden : false,
    }).element;
  tips.goToTwitter.clear()

  const loginSucceeded = () => {
    tips.twitterPassword.clear()
    userChoiceTracker?.processAnswer("RightTwitterPassword", true)
    tips.matrixPoster.clear();
    tips.solveMatrix.clear()
    tips.twitterExplained.setTime(20)

    render(Twitter({ feed: true }), puzzleWindow({ hidden: false }));
    document.querySelector("#parentTwitterWrapper").parentNode.style.display = "block"
    exitButtonPosition();
    resizeJobs();

    twitterScroller = iOSallowScroll("#twitter")

  };


  if (!noLogin) {
    LoginScreen(puzzleWindow, loginSucceeded);

  } else {

    loginSucceeded();

  }


  exitButtonPosition();

};

export default FlatPuzzle;
